import { createFileRoute } from '@tanstack/react-router';
import { UsuariosPage } from './-UsuariosPage';

export const Route = createFileRoute('/_auth/_shell/usuarios/')({
  component: UsuariosPage,
});
